(() => {
  const getLaunchers = () => {
    const wishlistHost = document.querySelector('.gw-widget-placeholder-RC > [data-order]');
    const chatRoot = document.querySelector('shopify-chat')?.shadowRoot;
    return {
      chat: chatRoot?.querySelector('button[part="activator"]') || chatRoot?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('button[part="activator"]'),
      loyalty: document.querySelector('#bon-loyalty-btn'),
      wishlist: wishlistHost?.shadowRoot?.querySelector('button.gw-launcher'),
      line: document.querySelector('#oc-plugin-line-icon a')
    };
  };
  const sync = () => {
    const launchers = getLaunchers();
    for (const [name, launcher] of Object.entries(launchers)) {
      document.body.classList.toggle(`hk-tool-ready-${name}`, Boolean(launcher));
      document.querySelectorAll(`[data-hk-tool="${name}"]`).forEach(button => { button.hidden = name === 'chat' ? false : !launcher; });
    }
  };
  const chatIsOpen = () => {
    const root = document.querySelector('shopify-chat')?.shadowRoot;
    const runtime = root?.querySelector('shopify-agent-runtime')?.shadowRoot;
    const activeRoot = runtime || root;
    const launcher = activeRoot?.querySelector('button[part="activator"]');
    return launcher?.getAttribute('aria-expanded') === 'true' &&
      Array.from(activeRoot.querySelectorAll('iframe')).some(frame => frame.getBoundingClientRect().height > 100);
  };
  let chatPending = false;
  document.addEventListener('click', event => {
    const contact = event.target.closest('a[data-hk-tool="chat"]');
    if (contact) {
      const launcher = getLaunchers().chat;
      if (!launcher) return; // Native contact link works before/without app initialization.
      event.preventDefault();
      contact.closest('header-drawer')?.querySelector('.menu-drawer__close-button')?.click();
      if (chatPending || chatIsOpen()) return;
      chatPending = true;
      launcher.click();
      let checks = 0;
      const opening = setInterval(() => {
        if (chatIsOpen()) {
          clearInterval(opening);
          chatPending = false;
        } else if (++checks >= 20) {
          clearInterval(opening);
          chatPending = false;
          window.location.assign(contact.href);
        }
      }, 200);
      return;
    }
    const button = event.target.closest('button[data-hk-tool]');
    if (!button) return;
    const launcher = getLaunchers()[button.dataset.hkTool];
    if (launcher) {
      button.closest('header-drawer')?.querySelector('.menu-drawer__close-button')?.click();
      launcher.click();
    }
  });
  let pending = false;
  const observer = new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; sync(); });
  });
  observer.observe(document.body, { childList: true, subtree: true });
  let attempts = 0;
  const timer = setInterval(() => { sync(); if (++attempts >= 20) clearInterval(timer); }, 500);
  sync();
})();
